export default {
  bind(el) {
    let scrollTimer;
    let crtList = []
    // 开始滚动
    const startScroll = () => {
      scrollTimer = setInterval(() => {

        if (new Set(crtList).size !== crtList.length) {
          crtList = []
          el.scrollLeft = 0;
        }
        if (crtList.length === 2) {
          crtList = []
        }

        el.scrollLeft += 1;
        crtList.push(el.scrollLeft)
      }, 50);
    };

    // 停止滚动
    const stopScroll = () => {
      clearInterval(scrollTimer);
    };

    el.addEventListener('mouseenter', stopScroll);
    el.addEventListener('mouseleave', startScroll);

    // 初始化滚动
    startScroll();
  },
  unbind(el) {
    el.removeEventListener('mouseenter', stopScroll);
    el.removeEventListener('mouseleave', startScroll);
    clearInterval(scrollTimer);
  }
};